type SearchBoxRecommendationsProps = {
	content: string;
	data: {
		url: string;
		label: string;
	}[];
	setOpenSearch: React.Dispatch<React.SetStateAction<boolean>> | undefined;
};

const SearchBoxRecommendations = ({
	content,
	data,
	setOpenSearch
}: SearchBoxRecommendationsProps) => {
	return (
		<div className="searchbox-recommendation">
			<h4 className="h4-italic-left-medium-cool-gray">{content}</h4>
			{data.map((recommendation, index) => {
				return (
					<a
						aria-label={recommendation.label}
						className="searchbox-recommendation-item"
						href={recommendation.url}
						key={index}
						onClick={() => setOpenSearch!(false)}
					>
						{recommendation.label}
					</a>
				);
			})}
		</div>
	);
};

export default SearchBoxRecommendations;
